import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPhone } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import Fullmap from "./map";
import { useNavigate, useLocation } from "react-router-dom";


const ContactUs = () => {
  const navigate = useNavigate();
    const location = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!formData.subject) newErrors.subject = "Subject is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    if (!captchaValue) newErrors.captcha = "Please verify the reCAPTCHA.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    alert("Form submitted successfully!");
  };

  return (
    <div className="py-16 px-6 lg:px-20 bg-dark text-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left Side - Contact Information */}
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl font-extrabold text-primary mb-6">
            Opening Hours: <span className="text-5xl">24/7</span>
          </h2>
          <p className="text-lg text-white opacity-90 mb-6 text-left">
          Watford Taxi – Your Local, Reliable Ride At Watford Taxi, we specialize in providing prompt and reliable transportation services. Whether you need a ride for a local journey or a smooth airport transfer, we've got you covered. Our fleet includes saloon cars, executive vehicles, and MPVs, ensuring comfort for individuals and groups. We offer competitive pricing, professional drivers, and easy online booking. From Heathrow to Gatwick and everywhere in between, trust us for your transport needs. Book your journey today!          </p>
          <p className="text-white opacity-80 flex items-center gap-3">
            <motion.span 
              className="w-12 h-12 flex items-center justify-center border-2 border-primary rounded-full"
              animate={{ opacity: [1, 0.5, 1] }}
              transition={{ repeat: Infinity, duration: 1 }}
            >
              <FaPhone className="text-primary text-xl" />
            </motion.span>
            <span className="text-3xl">01923 803 603</span>
          </p>
          <p className="text-white opacity-80 flex items-center gap-3 mt-5">
           <button 
        onClick={() => {
          // Navigate to home if not already there
          if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
              const bookNowSection = document.getElementById('book-now');
              if (bookNowSection) {
                bookNowSection.scrollIntoView({ behavior: 'smooth' });
              }
            }, 100); 
    } else {
      // Already on home page, just scroll
      const bookNowSection = document.getElementById('book-now');
      if (bookNowSection) {
        bookNowSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }}
             className="bg-primary text-gray-800 font-semibold py-2 px-6 rounded-lg border-2 border-primary transition duration-300 
                   hover:bg-transparent hover:border-primary hover:text-white">
              GET TAXI ONLINE
            </button>
          </p>
        </motion.div>

        {/* Right Side - Contact Form */}
        <motion.form 
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-lg shadow-2xl text-gray-900"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-bold text-primary mb-4">Send Us a Message</h3>

          <div className="mb-4">
            <label className="block text-gray-700 font-semibold text-left">
              Your Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Your Name"
            />
            {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 font-semibold text-left">
              E-mail <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Email"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 font-semibold text-left">
              Subject <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Subject"
            />
            {errors.subject && <p className="text-red-500 text-sm">{errors.subject}</p>}
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 font-semibold text-left">
              Message <span className="text-red-500">*</span>
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              rows="4"
              placeholder="Your Message"
            ></textarea>
            {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          </div>

          {/* reCAPTCHA */}
          <div className="mb-4">
            <ReCAPTCHA
              sitekey="6Ld5d9MqAAAAAC89sPT7gFI4eIRsZTwwBrNTm0jW"
              onChange={(value) => setCaptchaValue(value)}
            />
            {errors.captcha && <p className="text-red-500 text-sm">{errors.captcha}</p>}
          </div>

          <button
            type="submit"
            className="w-full bg-primary text-white font-semibold py-3 rounded-lg hover:bg-primary transition-all"
          >
            Send Message
          </button>
        </motion.form>
      </div>
      <Fullmap />
    </div>
  );
};

export default ContactUs;
